// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__35wUT","title":"BackImages_title__tKVwz","images":"BackImages_images__XmBc3"};